$(function () {
    const wrapper = $('#google-app-wrapper');

    if (wrapper.length > 0) {
        const closeButton = $('#google-app-button-close');
        closeButton.click(function () {
            wrapper.remove();
        });
    }
});
